import sendRequest from "../fetch"
import api from '../url'
import Qs from 'qs'
import { cleanParams } from "@/utils";

const _base = "sysNotice/";

// 系统通知 - 列表查询-分页
export const sysNoticePage = (params) => {
         let _params = cleanParams(params);
         return sendRequest(api.url + _base + "page", {
           data: _params,
           method: "GET",
         });
       };
// 系统通知 - 获取最新的一条通知信息
export const sysNoticelast = (params) => {
         let _params = cleanParams(params);
         return sendRequest(api.url + _base + "last", {
           data: _params,
           method: "GET",
         });
       };


// WEBPACK FOOTER //
// ./src/fetch/api/systemNotice.js